<template>
  <div class="login">
    <div class="contain" v-show="islogin">
      <div class="first">
        <div class="userLogin">
          <img src="../assets/img/email.png" alt="" />
          <input type="text" placeholder="用户邮箱/手机" />
        </div>
        <div class="userLogin">
          <img src="../assets/img/password.png" alt="" />
          <input type="password" placeholder="用户密码" />
        </div>
        <div>
          <a href=""><p>忘记密码？</p></a>
        </div>
      </div>
      <div class="Geetest" id="Geetest">
        <!-- <img src="../assets/img/yz.png" alt="" /> -->
        <!-- <button @click="handleClick">在父组件可以点我刷新哦</button>
        <div>{{ msg }}</div> -->
        <el-button type="primary" @click="dialogVisible2 = true" v-if="!this.vtype"
          >点击验证</el-button
        >
		<span v-else>验证成功</span>
      </div>
      <div class="third">
        <div class="loginUser">
          <button>登 录</button>
        </div>
        <div class="guge">
          <span>第三方登录</span>
          <div style="display: inline-block">
            <span><img src="../assets/img/weixin.png" alt="" />微信</span>
            <span id="qqLogin" class="qqLogin" style="height: 21px"></span>
            <span><img src="../assets/img/qq.png" alt="" />QQ</span>
          </div>
        </div>
        <p>沒有账户，<span @click="islogin = false">点击注册</span></p>
      </div>
    </div>
    <div class="contain" v-show="!islogin">
      <div class="first">
        <div class="userLogin">
          <img src="../assets/img/email.png" alt="" />
          <input type="text" placeholder="用户邮箱/手机" />
        </div>
        <div class="userLogin">
          <img src="../assets/img/password.png" alt="" />
          <input type="password" placeholder="用户密码" />
        </div>
        <div class="sc-jzJRlG ctJIms">
          <input type="checkbox" class="sc-cSHVUG dwqlB" />
          <span
            >已经阅读并<span
              class="sc-kAzzGY kHnacM"
              @click="dialogVisible = true"
              >《用户注册协议》</span
            >和<span class="sc-chPdSV ilQDEZ" @click="dialogVisible1 = true"
              >《隐私协议》</span
            ></span
          >
        </div>
      </div>
      <div class="Geetest" id="Geetest">
        <img src="../assets/img/yz.png" alt="" />
      </div>
      <div class="third">
        <div class="loginUser">
          <button>注 册</button>
        </div>
        <div class="guge">
          <button @click="islogin = true">登 录</button>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="780px"
      :before-close="handleClose"
      title="用户注册协议"
      class="first_one"
    >
      <UserAgreetment></UserAgreetment>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisible1"
      :append-to-body="true"
      width="780px"
      :before-close="handleClose"
      title="隐私协议"
      class="first_one"
    >
      <PrivacyAgreement></PrivacyAgreement>
    </el-dialog>
    <el-dialog
      title="请完成安全验证"
      :visible.sync="dialogVisible2"
      width="330px"
      :before-close="handleClose"
      class="verifyBox"
    >
      <slide-verify
        ref="slideblock"
        @again="onAgain"
        @fulfilled="onFulfilled"
        @success="onSuccess"
        @fail="onFail"
        @refresh="onRefresh"
        :slider-text="text"
        :accuracy="accuracy"
      ></slide-verify>
    </el-dialog>
  </div>
</template>

<script>
import UserAgreetment from "./page/UserAgreement.vue";
import PrivacyAgreement from "./page/PrivacyAgreement.vue";
export default {
  components: { UserAgreetment, PrivacyAgreement },
  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      islogin: true,
      msg: "",
      text: "向右滑动完成验证",
      // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
      accuracy: 1,
	  vtype:false
    };
  },
  methods: {
    handleClose(done) {
      done();
    },
    onSuccess(times) {
      console.log("验证通过，耗时 " + times + "毫秒");
      this.msg = `验证成功, 耗时${(times / 1000).toFixed(1)}s`;
      this.dialogVisible2 = false;
      this.vtype = true;
    },
    onFail() {
      console.log("验证不通过");
      this.msg = "";
      this.vtype = false;
    },
    onRefresh() {
      console.log("点击了刷新小图标");
      this.msg = "";
    },
    onFulfilled() {
      console.log("刷新成功啦！");
    },
    onAgain() {
      console.log("检测到非人为操作的哦！");
      this.msg = "try again";
      // 刷新
      this.$refs.slideblock.reset();
    },
    handleClick() {
      this.$refs.slideblock.reset();
    },
  },
};
</script>

<style scoped>
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
}

a {
  text-decoration: none;
}

.header-title {
  display: flex;
}

.title_add_student {
  margin: 0 auto;
  color: #fff;
}

.login {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: auto;
}

.login .contain {
  width: 20%;
  min-width: 400px;
  margin: 0 auto;
  background: #fff;
  border-radius: 5px;
  padding: 20px;
  -webkit-box-shadow: 0 0 20px #eee;
  box-shadow: 0 0 20px #eee;
}

.contain {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.first {
  padding: 0px 20px;
  margin-top: 25px;
}

.login .userLogin {
  margin-top: 25px;
  position: relative;
}

.login .userLogin img {
  display: inline-block;
  width: 23px;
  padding-right: 5px;
  border-right: 1px solid #2a97ff;
  position: absolute;
  top: 13px;
  left: 5px;
}

.login .userLogin input {
  width: 85%;
  padding: 18px 0 15px 40px;
  outline: none;
  border: 1px solid #ccc;
  font-size: 14px;
}

.login .contain p:first-child {
  text-align: right;
  color: #2a97ff;
}

.login p {
  margin: 15px 0;
  font-size: 12px;
  text-align: center;
}

.second {
  display: block;
  height: 44px;
}

.one {
  display: none;
  line-height: 44px;
  text-align: center;
}

.two {
  display: block;
}

.Geetest {
  width: 350px;
  margin: 0 auto;
}

.Geetest > img {
  width: 100%;
  height: 100%;
}

.login .loginUser button {
  width: 100%;
  color: #fff;
  background: #2a97ff;
  padding: 10px;
  border-radius: 10px;
  border: none;
  font-size: 18px;
  text-align: center;
  outline: none;
  cursor: pointer;
  margin-top: 10px;
}

.login .guge {
  font-size: 16px;
  color: #8590a6;
  height: 60px;
  line-height: 60px;
}

.login .guge div {
  float: right;
}

.login .guge div span {
  margin-left: 10px;
  cursor: pointer;
}

.login .guge div span img {
  vertical-align: middle;
  width: 18px;
  margin-right: 6px;
}

.qqLogin {
  position: absolute;
  width: 50px;
  opacity: 0;
}

.login p span {
  color: #2a97ff;
  cursor: pointer;
}

.ctJIms {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  margin-top: 10px;
  margin: 15px 0;
  font-size: 12px;
}

.dwqlB {
  cursor: pointer;
  margin-right: 5px;
}

.kHnacM,
.ilQDEZ {
  color: rgb(42, 151, 255);
  cursor: pointer;
}

.login .guge button {
  width: 100%;
  background: #f26875;
  margin-top: 9px;
  font-size: 18px;
  border: none;
  outline: none;
  cursor: pointer;
  color: #fff;
  padding: 10px;
  border-radius: 10px;
  text-align: center;
}

.first_one >>> .el-dialog__header {
  background: rgb(61, 103, 188);
  padding: 15px 20px !important;
}

.first_one >>> .el-dialog__title {
  color: #fff;
}

.verifyBox >>> .el-dialog__body {
  padding: 10px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue